import { getProductsList } from './tmr-products.js';
import { getProductsTotal } from './tmr-products.js';

export function tmrProductView(product) {
    return Promise.resolve({
        type: 'itemView',
        productid: product.bitrixID,
        pagetype: 'product',
        list: '1',
        totalvalue: product.price
    });
}